import { Col, Modal, Row } from "antd";
import React from "react";
import styled from "styled-components";
import Button from "../Button/Button";
import Text from "../Text/Text";
import color from "../../resource/color";
import TextArea from "../Input/TextArea";

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }
  .ant-modal-body {
    padding: 0;
  }
`;
interface Props {
  typeButtonCancel?: any;
  title?: string | React.ReactNode;
  visible?: boolean;
  onConfirm?: () => void;
  onCancel?: () => void;
  desc?: string | React.ReactNode;
  bodyStyle?: React.CSSProperties;
  cancelText?: string;
  confirmText?: string;
  loading?: boolean;
  isInput?: boolean;
  callBackInput?: (val) => void;
  disabled?: boolean;
  typeButtonSubmit?: any;
}
function ConfirmModal({
  desc,
  onCancel,
  onConfirm,
  title = "ยืนยันการบันทึกข้อมูล",
  visible,
  bodyStyle,
  cancelText = "ยกเลิก",
  confirmText = "ยืนยัน",
  loading,
  isInput = false,
  callBackInput,
  disabled = false,
  typeButtonCancel = "primary-light",
  typeButtonSubmit = "primary",
}: Props) {
  const closeModal = () => {
    onCancel?.();
    callBackInput?.(undefined);
  };
  return (
    <ModalStyled open={visible} closable={false} centered footer={null}>
      <Text level={2}>{title}</Text>
      <div style={{ marginBottom: 22 }}>
        <Text fontFamily='Sarabun' color='Text3'>
          {desc}
        </Text>
      </div>
      {isInput && (
        <>
          <Text fontFamily='Sarabun' fontSize={14}>
            เหตุผล <span style={{ color: color.error }}>*</span>
          </Text>
          <TextArea
            placeholder='ระบุเหตุผลการแก้ไข'
            onChange={(value) => callBackInput?.(value.target.value)}
          />
        </>
      )}
      <Row
        style={{
          display: "flex",
          justifyContent: "flex-end",
          borderTop: "1px solid #E5E5E5",
        }}
      >
        <Col
          style={{
            gap: 8,
            display: "flex",
            marginTop: 22,
          }}
        >
          <Button
            title={cancelText}
            // disabled={disabled}
            typeButton={typeButtonCancel}
            onClick={closeModal}
          />
          <Button
            disabled={disabled}
            typeButton={disabled ? "disabled" : typeButtonSubmit}
            title={confirmText}
            onClick={onConfirm}
            loading={loading}
          />
        </Col>
      </Row>
    </ModalStyled>
  );
}

export default ConfirmModal;
